import React, { FC } from 'react';
import { SC } from '../../styles/theme';

export const DealPreviewTemplate: FC<SC> = ({ className, children, id }: SC & { id?: string }) => {
    return (
        <div id={id} className={className}>
            {children}
        </div>
    );
};
